import { render, staticRenderFns } from "./extra-notification.vue?vue&type=template&id=1a9de18e&lang=pug&"
import script from "./extra-notification.vue?vue&type=script&lang=js&"
export * from "./extra-notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports